const STATUS_COLORS: Record<string, string> = {
  active: "bg-emerald-500/10 text-emerald-500",
  enrolled: "bg-emerald-500/10 text-emerald-500",
  completed: "bg-emerald-500/10 text-emerald-500",
  open: "bg-amber-500/10 text-amber-500",
  pending: "bg-amber-500/10 text-amber-500",
  pending_validation: "bg-amber-500/10 text-amber-500",
  in_progress: "bg-blue-500/10 text-blue-500",
  screening: "bg-blue-500/10 text-blue-500",
  answered: "bg-blue-500/10 text-blue-500",
  paused: "bg-slate-500/10 text-slate-400",
  inactive: "bg-slate-500/10 text-slate-400",
  closed: "bg-slate-500/10 text-slate-400",
  error: "bg-red-500/10 text-red-500",
  failed: "bg-red-500/10 text-red-500",
  critical: "bg-red-500/10 text-red-500",
  no_show: "bg-red-500/10 text-red-500",
  scheduled: "bg-blue-500/10 text-blue-500",
  acknowledged: "bg-blue-500/10 text-blue-500",
  resolved: "bg-emerald-500/10 text-emerald-500",
  trialing: "bg-blue-500/10 text-blue-500",
  past_due: "bg-amber-500/10 text-amber-500",
  canceled: "bg-red-500/10 text-red-500",
  trial: "bg-blue-500/10 text-blue-500",
  professional: "bg-indigo-500/10 text-indigo-500",
  enterprise: "bg-purple-500/10 text-purple-500",
  paid: "bg-emerald-500/10 text-emerald-500",
};

const DEFAULT_COLOR = "bg-slate-500/10 text-slate-400";

export function StatusBadge({ status }: { status: string | null }) {
  if (!status) return null;
  const normalized = status.toLowerCase().replace(/\s+/g, "_");
  const color = STATUS_COLORS[normalized] ?? DEFAULT_COLOR;
  return (
    <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${color}`}>
      {status}
    </span>
  );
}
